export default "__VITE_ASSET__BzPXkvew__"